import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"

import Link from "@atoms/link"
import { Heading } from "@atoms/typography"
import Card from "@molecules/cards/card"
import Date from "@utils/date"

const CardPost = ({ post }) => {
  return (
    <Card>
      <PostLink to={`/${post.slug}`}>
        <Image>
          {post.featuredImage && (
            <GatsbyImage
              image={post.featuredImage.gatsbyImageData}
              alt={post.featuredImage.alt}
            />
          )}
        </Image>
        <Content>
          <Seperator />
          <DateHeading html="h6" level="sh" strong lightGray>
            <Date date={post.meta.firstPublishedAt} />
          </DateHeading>
          <Title html="h3" level="h4">
            {post.title}
          </Title>
          <SubContent>
            <Category html="h6" level="sh" strong aqua>
              {post.category.title}
            </Category>
            <Heading html="h6" level="sh" strong lightGray>
              {post.author.name}
            </Heading>
          </SubContent>
        </Content>
      </PostLink>
    </Card>
  )
}

export default CardPost

const Image = styled.div`
  position: relative;
  width: 100%;

  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: calc((8 / 17) * 100%);
  }

  .gatsby-image-wrapper {
    left: 0;
    position: absolute !important;
    top: 0;
    width: 100%;
    height: 100%;
  }
`

const Content = styled.div`
  padding: 3rem var(--spacing--xs);
  position: relative;
`

const Seperator = styled.div`
  border-bottom: 4px solid var(--colorPrimary);
  left: 0;
  position: absolute;
  top: 0;
  transform: scaleX(0.25);
  transform-origin: left top;
  transition: var(--transitionBase);
  width: 100%;
`

const SubContent = styled.div`
  display: flex;
`

const DateHeading = styled(Heading)`
  margin-bottom: 1rem;
`

const Title = styled(Heading)`
  padding-bottom: 1.5rem;
`

const Category = styled(Heading)`
  padding-right: 1rem;
`

const PostLink = styled(Link)`
  &:hover {
    ${Seperator} {
      transform: scaleX(1);
    }
  }
`
